import { render, staticRenderFns } from "./OrderItemsFormTab.vue?vue&type=template&id=3e50743e&scoped=true"
import script from "./OrderItemsFormTab.vue?vue&type=script&lang=js"
export * from "./OrderItemsFormTab.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsFormTab.vue?vue&type=style&index=0&id=3e50743e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e50743e",
  null
  
)

export default component.exports